import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cellContentSearch]',
})
export class CellContentSearch {
  constructor(public templateRef: TemplateRef<any>) {}
}
